import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('createFarmForm');

    return {
        CREATE: t('create')
    };
};

export default useTranslation;
